module.exports = __webpack_public_path__ + "img/tools_forecast_predictor.5d0c613a.png";